module.exports = __webpack_public_path__ + "manageStatic/img/logo.a9dadc6a.png";